

const link = {
    link1: 'https://docs.jodoworld.com/index.php/docs/jodo-bpp-unified-toolbar/jodolink-use-case-videosmarketing/qr-code/',
    link2: 'https://docs.jodoworld.com/index.php/docs/jodo-bpp-unified-toolbar/jodolink-use-case-videosmarketing/email-signature/',
    link3: 'https://docs.jodoworld.com/index.php/docs/jodo-bpp-unified-toolbar/jodolink-use-case-videosmarketing/banner-ads/'
}


export default link